import * as React from 'react';
import type { SVGProps } from 'react';
const SvgETraReference = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none" {...props}>
    <path fill="#616061" fillRule="evenodd" d="M5 14v-3h4v3h2v-3h3V9h-3V5h3V3h-3V0H9v3H5V0H3v3H0v2h3v4H0v2h3v3zm4-5H5V5h4z" clipRule="evenodd" />
  </svg>
);
export default SvgETraReference;
